// extracted by mini-css-extract-plugin
export default {"badgeContainer":"styles-module__badgeContainer___-74aU","badge":"styles-module__badge___-XTNY","footerText":"styles-module__footerText___u-lAQ"};